import './styles.sass';
import { getNameByLocation, isEmpty }  from '../../../../utils/utils';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MERGER_ARBITRAGE } from "../../../../utils/constants";

export default function RiskProfileTable({ items, familyId }) {
  const { t, i18n } = useTranslation();
  const isLtr = i18n.language === 'en';
  
  let indices = [items[0]];
  if (familyId !== null) {
    indices = items?.filter((obj) => obj.family_id === familyId);
  }

  return (
    <table className="rpt-family-table" cellSpacing="0" rules="all" border="1">
      <thead className="family-table-header">
        <tr>
          <th rowSpan="2" className="family-table-header-cell" scope="col">
            {t('RiskProfileTable.index')}
          </th>
          <th scope="col" className="family-table-header-cell family-table-header-cell-height" dir={isLtr ? 'ltr' : 'rtl'}>
            {t('RiskProfileTable.std_dev')}
          </th>
          <th scope="col" className="family-table-header-cell family-table-header-cell-height">
            {t('RiskProfileTable.sharpe_ratio')}
          </th>
          <th scope="col" className="family-table-header-cell family-table-header-cell-height" dir={isLtr ? 'ltr' : 'rtl'}>
            {t('RiskProfileTable.draw_down')}
          </th>
        </tr>
      </thead>
      {indices.map((index) => (
        <tbody key={index.id}>
          <tr className="family-table-row family-table-row-gray">
            <td className="family-table-name" dir="ltr" style={{ textAlign: isLtr ? 'left' : 'right' }}>
              {index.name}
            </td>
            <td dir="ltr" className="family-table-cell">
              {isEmpty(index.statistics.index_return[1])
                ? '-'
                : (index.statistics.index_return[1]['std'] * 100).toFixed(2)}
            </td>
            <td dir="ltr" className="family-table-cell">
              {isEmpty(index.statistics.index_return[1])
                ? '-'
                : (index.statistics.index_return[1]['sharpe_ratio']).toFixed(2)}
            </td>
            <td dir="ltr" className="family-table-cell">
              {isEmpty(index.statistics.index_return[1])
                ? '-'
                : (index.statistics.index_return[1]['draw_downs'] * 100).toFixed(2)}
            </td>
          </tr>
          {index.parent_index && index.id !== MERGER_ARBITRAGE && (
            <tr className="family-table-row family-table-row-gray">
              <td dir="ltr" className="family-table-name" style={{ textAlign: isLtr ? 'left' : 'right' }}>
                {getNameByLocation(items.find((obj) => obj.id === index.parent_index), i18n) || '-'}
              </td>
              <td dir="ltr" className="family-table-cell">
                {isEmpty(index.statistics.benchmark_return[1])
                  ? '-'
                  : (index.statistics.benchmark_return[1]['std'] * 100).toFixed(2)}
              </td>
              <td dir="ltr" className="family-table-cell">
                {isEmpty(index.statistics.benchmark_return[1])
                  ? '-'
                  : (index.statistics.benchmark_return[1]['sharpe_ratio']).toFixed(2)}
              </td>
              <td dir="ltr" className="family-table-cell">
                {isEmpty(index.statistics.benchmark_return[1])
                  ? '-'
                  : (index.statistics.benchmark_return[1]['draw_downs'] * 100).toFixed(2)}
              </td>
            </tr>
          )}
        </tbody>
      ))}
    </table>
  );
}

RiskProfileTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      item_type: PropTypes.string,
      statistics: PropTypes.object,
    })
  ).isRequired,
  familyId: PropTypes.string,
};
